import { LocationVarKey } from "@swivl-mono/types";

import { IS_EQUAL, IS_NOT_EQUAL, IS_TRUE } from "../../../Components/Worksheets/Types/Worksheet.Interface";
import {
  DropdownRow,
  Indent,
  InputRow,
  MultiLineRow,
  PageHeader,
  Section,
  SectionHeader,
  SwitchRow,
  TextAreaRow,
  TextRow
} from "../../../Components/Worksheets/WorksheetComponent/WorksheetComponents";
import { usePropertiesGetLocationIds } from "../../../Hooks/usePropertiesGetLocationIds";

export const PAGE_KEYS: LocationVarKey[] = [
  LocationVarKey.HasProfileSettingShoppingCollectProfile,
  LocationVarKey.ProfileSettingShoppingMessage,
  LocationVarKey.ProfileSettingShoppingCollectionMethod,
  LocationVarKey.ProfileSettingShoppingContactMethod,
  LocationVarKey.ProfileSettingShoppingWantShortProfile,
  LocationVarKey.ProfileSettingShoppingWantSecondaryOptional,
  LocationVarKey.ProfileSettingShoppingWantConfirmProfile
];

export default function WorksheetView() {
  const page = usePropertiesGetLocationIds();
  return (
    <>
      <PageHeader
        {...page}
        subheading="Collect contact information after a user has selected a unit from your inventory carousel and before sending them to a reservation page."
      >
        Shopping Funnel
      </PageHeader>

      <SwitchRow {...page} keyName={LocationVarKey.HasProfileSettingShoppingCollectProfile} label="Collect Profile" />
      <Section {...page} hideIf={IS_NOT_EQUAL(LocationVarKey.HasProfileSettingShoppingCollectProfile, "1")}>
        <TextAreaRow {...page} marginTop label=" Message 1" keyName={LocationVarKey.ProfileSettingShoppingMessage} />
        <DropdownRow
          {...page}
          marginTop
          label=" Collection Method"
          keyName={LocationVarKey.ProfileSettingShoppingCollectionMethod}
          options={[
            {
              label: "Conversational",
              value: "Conversational"
            },
            {
              label: "Info Collect Card",
              value: "Card"
            }
          ]}
        />
        <DropdownRow
          {...page}
          marginTop
          label=" Preferred Contact Method"
          keyName={LocationVarKey.ProfileSettingShoppingContactMethod}
          options={[
            {
              label: "Phone Number",
              value: "Phone"
            },
            {
              label: "Email",
              value: "Email"
            }
          ]}
        />
        <SwitchRow {...page} keyName={LocationVarKey.ProfileSettingShoppingWantShortProfile} label="Short Profile" />
        <Indent {...page}>
          <SwitchRow
            {...page}
            keyName={LocationVarKey.ProfileSettingShoppingWantSecondaryOptional}
            hideIf={IS_NOT_EQUAL(LocationVarKey.ProfileSettingShoppingWantShortProfile, "1")}
            label="Make Secondary Contact Method Optional"
          />
        </Indent>
        <SwitchRow {...page} keyName={LocationVarKey.ProfileSettingShoppingWantConfirmProfile} label="Confirm Profile" />
      </Section>
    </>
  );
}
